import { render, staticRenderFns } from "./dashDistributorsLub.vue?vue&type=template&id=f9518bf6&scoped=true&"
import script from "./dashDistributorsLub.vue?vue&type=script&lang=js&"
export * from "./dashDistributorsLub.vue?vue&type=script&lang=js&"
import style0 from "./dashDistributorsLub.vue?vue&type=style&index=0&id=f9518bf6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9518bf6",
  null
  
)

export default component.exports